var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6782 1.31384L12.6274 10.3646L3.57641 1.31363C2.95203 0.68925 1.93819 0.68925 1.31361 1.31384C0.689226 1.93822 0.689226 2.95205 1.3136 3.57643L10.3646 12.6274L1.3136 21.6784C0.689226 22.3028 0.689226 23.3167 1.31361 23.941C1.93819 24.5656 2.95203 24.5656 3.57641 23.9413L12.6274 14.8902L21.6782 23.941C22.3028 24.5656 23.3166 24.5656 23.941 23.9413C24.5656 23.3167 24.5656 22.3028 23.941 21.6782L14.8902 12.6274L23.941 3.57664C24.5656 2.95205 24.5656 1.93822 23.941 1.31363C23.3166 0.689251 22.3028 0.68925 21.6782 1.31384Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c187098cf493afaf87fa98960033fe03.svg";
export { ForwardRef as ReactComponent };